// assets
import RadarChartOutlined from '@ant-design/icons/RadarChartOutlined';

// icons
const icons = { RadarChartOutlined };

// ==============================|| MENU ITEMS - ANIMALS ||============================== //

const animals = {
  id: 'group-animals',
  title: 'Livestock',
  type: 'group',
  children: [
    {
      id: 'animals',
      title: 'Animals',
      type: 'item',
      url: '/animals',
      icon: icons.RadarChartOutlined,
      breadcrumbs: false
    }
  ]
};

export default animals;
